import { TableColumn } from "react-data-table-component";
import { Topic } from "../../../../core/topic/entities/Topic";
import { ExternalLink } from "lucide-react";
import { TranslationFunction } from "../../../../utils/utils";
import CachedImage from "../../../components/image/CachedImage";
import { badgeClasses } from "../../../constants/badgeClasses";
import { statusOptions } from "./topicFormConfig";

export const topicStatusBadgeClasses: Record<string, string> = {
  draft: badgeClasses.primary,
  available: badgeClasses.success,
  unavailable: badgeClasses.error,
};

export const levelBadgeClasses: Record<string, string> = {
  all: badgeClasses.secondary,
  beginner: badgeClasses.primary,
  intermediate: badgeClasses.primary,
  advanced: badgeClasses.primary,
};

const topicTableConfig = (
  t: TranslationFunction,
  topicPath: (id: string) => string
): TableColumn<Topic>[] => [
  {
    name: "topic.field.rank",
    selector: (row: Topic) => row.rank ?? "",
    width: "60px",
    sortable: true,
  },
  {
    name: "testimony.field.image",
    width: "75px",
    cell: (row: Topic) =>
      row.image ? (
        <CachedImage
          src={row.image}
          alt={row.title}
          className="w-10 h-10 object-cover rounded-lg"
        />
      ) : (
        <div></div>
      ),
  },
  {
    name: "topic.field.title",
    selector: (row: Topic) => row.title,
    style: {
      minWidth: "300px",
    },
  },
  {
    name: "topic.field.description",
    selector: (row: Topic) => row.description ?? "",
    width: "300px",
  },
  {
    name: "topic.field.status",
    selector: (row: Topic) =>
      t(row.status in statusOptions ? statusOptions[row.status] : ""),
    cell: (row: Topic) => (
      <span className={topicStatusBadgeClasses[row.status]}>
        {t(row.status in statusOptions ? statusOptions[row.status] : "")}
      </span>
    ),
  },
  {
    name: "topic.field.level",
    selector: (row: Topic) => t(`topic.level.${row.level ?? "all"}`),
    cell: (row: Topic) => (
      <span className={levelBadgeClasses[row.level ?? "all"]}>
        {t(`topic.level.${row.level ?? "all"}`)}
      </span>
    ),
  },
  {
    name: "",
    width: "50px",
    cell: (row: Topic) => (
      <a href={topicPath(row.id)}>
        <ExternalLink className="w-4 h-4" />
      </a>
    ),
  },
];

export default topicTableConfig;
